import { observer } from "mobx-react-lite";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { user } from "@/endpoints/dryp/user";
import { Button } from "@/components/ui/button";
import { List } from "@/components/List";
import { useUserColumns } from "./Columns";
import { useServerTable } from "@/hooks/useServerTable";
import { useStore } from "@/hooks/useStore";
import { getTableSearchParam } from "@/utils/filters";
import { CUSTOM_FILTERS } from "@/config/list";

export const Users = observer(() => {
	const getUsersApi = useAsyncStateStore(user.getUsers, { debounce: 300 });

	const refresh = () => {
		getUsersApi.fetch({ pageNumber: 0, pageSize: 10 });
	};
	const columns = useUserColumns(refresh);
	const { table } = useServerTable({
		columns: columns,
		data: getUsersApi.data?.items || [],
		fetchFn: params =>
			getUsersApi.fetch(
				{ pageNumber: params.page, pageSize: params.pageSize },
				params.sort,
				getTableSearchParam(params?.filters),
			),
		initialValues: {
			page: 0,
			pageSize: 10,
		},
	});

	const {
		uiStore: { modalStore },
		userStore,
	} = useStore();

	const canManageUsers = userStore.isAdmin || userStore.isSuperAdmin;

	return (
		<div className="flex flex-col gap-4 md:gap-6 p-4 md:p-6">
			<header className="flex items-center justify-between">
				<h1 className="text-2xl md:text-4xl font-semibold tracking-tight">Users</h1>
				{canManageUsers && (
					<Button onClick={() => modalStore.open("addUser", { onSuccess: refresh })} size="sm">
						+ Add
					</Button>
				)}
			</header>

			<List
				table={table}
				pagination={{
					total: getUsersApi.data?.query?.pagination.totalItems || 0,
				}}
				toolbar={{
					filterKey: CUSTOM_FILTERS.search,
				}}
				layout={{
					loading: getUsersApi.loading,
				}}
			/>
		</div>
	);
});
